import type { CSSProperties, ReactNode } from 'react';
import { useId } from 'react';
import { cx } from '@/shared/lib/cx';
import s from './Meter.module.css';

export interface MeterProps {
  label: ReactNode;
  value: number;
  max: number;
  /** Текст значения («Использовано 95 из 100»). */
  valueText: string;
  /** Пороги: от warning — жёлтый, от danger — красный (доли 0…1). По умолчанию 0,8 и 1 (ПОРТ-32). */
  warningAt?: number;
  dangerAt?: number;
  className?: string;
}

/** Индикатор расхода лимита: дорожка того же тона, заполнение по порогам 80% и 100% (ПОРТ-32). */
export function Meter({ label, value, max, valueText, warningAt = 0.8, dangerAt = 1, className }: MeterProps) {
  const labelId = useId();
  const ratio = max > 0 ? Math.min(Math.max(value / max, 0), 1) : 0;
  const level = max > 0 && value / max >= dangerAt ? 'danger' : max > 0 && value / max >= warningAt ? 'warning' : 'normal';
  return (
    <div className={cx(s.meter, className)}>
      <div className={s.row}>
        <span id={labelId} className={s.label}>
          {label}
        </span>
        <span className={s.value} aria-hidden="true">
          {valueText}
        </span>
      </div>
      <div
        role="meter"
        aria-labelledby={labelId}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={Math.min(value, max)}
        aria-valuetext={valueText}
        className={s.track}
        data-level={level}
      >
        <span className={s.fill} style={{ '--ratio': ratio } as CSSProperties} />
      </div>
    </div>
  );
}
